module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "assignmentWrapper"
    }
  }, [_c('grid-details-modal', {
    attrs: {
      "id": _vm.modalId,
      "closable": true,
      "tabs": _vm.modalDetailsTabs,
      "defaultTab": _vm.defaultTab,
      "labelModalTitle": _vm.modalTitle,
      "labelModalSubTitle": _vm.modalSubTitle,
      "isOpen": _vm.isOpenDetailsModal
    },
    on: {
      "closeDetailsModal": _vm.closeDetailsModal
    }
  }), _c('div', {
    staticClass: "page-content-wrapper"
  }, [_c('div', {
    staticClass: "container-fluid container-fixed-lg"
  }, [_c('div', {
    staticClass: "panel panel-transparent"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('page-title', {
    attrs: {
      "title": _vm.$t('consultaTarefa.titulos.titulo'),
      "subTitle": _vm.$t('consultaTarefa.titulos.subtitulo')
    }
  }), _c('filter-portlet', {
    attrs: {
      "portletTitle": _vm.$t('consultaTarefa.titulos.filtroTitulo')
    }
  }, [_c('form', {
    attrs: {
      "slot": "filters"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validate.apply(null, arguments)
      }
    },
    slot: "filters"
  }, [_c('div', {
    staticClass: "row-filter-small"
  }, [_c('div', {
    staticClass: "col-xs-6 pl-0"
  }, [_c('div', {
    staticClass: "col-xs-12 px-0"
  }, [_c('div', {
    staticClass: "col-xs-12 px-0"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "selectQueryBase"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('consultaTarefa.labels.baseConsulta'))
    }
  })]), _c('div', {
    staticClass: "col-md-12 col-sm-12 col-xs-12 px-0"
  }, [_c('v-select', {
    attrs: {
      "options": _vm.queryBaseOptions,
      "label": "label",
      "placeholder": _vm.$t('validacao.select.placeholder'),
      "data-vv-name": "queryBaseSelected",
      "id": "queryBaseSelect",
      "name": "queryBaseSelect"
    },
    on: {
      "input": _vm.showDatePicker
    },
    model: {
      value: (_vm.queryBaseSelected),
      callback: function($$v) {
        _vm.queryBaseSelected = $$v
      },
      expression: "queryBaseSelected"
    }
  }, [_c('span', {
    attrs: {
      "slot": "no-options"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('consultaTarefa.labels.nenhumResultado'))
    },
    slot: "no-options"
  })])], 1)])]), (_vm.showDate) ? _c('div', {
    staticClass: "col-xs-6 px-0"
  }, [_c('date-range', {
    ref: "dateRange",
    attrs: {
      "initialFromDate": _vm.firstDate,
      "initialToDate": _vm.finalDate,
      "maxRange": 200,
      "finalDateDisableFrom": _vm.finalDateDisable
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1) : _vm._e()]), _c('div', {
    staticClass: "clear"
  }), _c('div', {
    staticClass: "row-filter-small col-xs-12 px-0"
  }, [_c('div', {
    staticClass: "col-xs-12 px-0"
  }, [_c('div', [_c('div', {
    staticClass: "checkbox check-success col-xs-1 pl-0 status-filter spaced-bottom-top"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.assignCheck),
      expression: "assignCheck"
    }],
    attrs: {
      "id": "assignedToMe",
      "type": "checkbox",
      "name": "assign"
    },
    domProps: {
      "checked": Array.isArray(_vm.assignCheck) ? _vm._i(_vm.assignCheck, null) > -1 : (_vm.assignCheck)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.assignCheck,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.assignCheck = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.assignCheck = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.assignCheck = $$c
        }
      }, _vm.trackCheckBox]
    }
  }), _c('label', {
    staticClass: "control-label func-group-labels check-atribuidas",
    attrs: {
      "for": "assignedToMe"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('consultaTarefa.labels.atribuidas'))
    }
  })])])])]), _c('div', {
    staticClass: "row-filter-small"
  }, [_c('div', {
    staticClass: "col-xs-6 pl-0"
  }, [_c('div', {
    staticClass: "col-xs-12 px-0"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "typeLinkSelect"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('consultaTarefa.labels.origem'))
    }
  })]), _c('div', {
    staticClass: "col-md-12 col-sm-12 col-xs-12 px-0"
  }, [_c('v-select', {
    attrs: {
      "multiple": "multiple",
      "options": _vm.filteredOriginOptions,
      "label": "label",
      "placeholder": _vm.$t('validacao.select.placeholder'),
      "data-vv-name": "typeLinkSelected",
      "id": "typeLinkSelect",
      "name": "typeLinkSelect"
    },
    on: {
      "input": _vm.trackOrigem
    },
    model: {
      value: (_vm.typeLinkSelected),
      callback: function($$v) {
        _vm.typeLinkSelected = $$v
      },
      expression: "typeLinkSelected"
    }
  }, [_c('span', {
    attrs: {
      "slot": "no-options"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('consultaTarefa.labels.nenhumResultado'))
    },
    slot: "no-options"
  })])], 1)])]), _c('div', {
    staticClass: "row-filter-small col-xs-12 px-0"
  }, [_c('div', {
    staticClass: "col-xs-12 px-0"
  }, [_c('label', {
    staticClass: "control-label",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('consultaTarefa.labels.situacaoLabel'))
    }
  }), _vm._l((_vm.situationList), function(situation, idx) {
    return _c('div', [_c('div', {
      staticClass: "checkbox check-success col-xs-1 pl-0 status-filter"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (situation.checked),
        expression: "situation.checked"
      }],
      attrs: {
        "id": situation.id,
        "type": "checkbox",
        "name": "situation"
      },
      domProps: {
        "checked": Array.isArray(situation.checked) ? _vm._i(situation.checked, null) > -1 : (situation.checked)
      },
      on: {
        "change": [function($event) {
          var $$a = situation.checked,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(situation, "checked", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(situation, "checked", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(situation, "checked", $$c)
          }
        }, function($event) {
          return _vm.trackCheckBoxSituacao(situation.nome)
        }]
      }
    }), _c('label', {
      staticClass: "func-group-labels",
      attrs: {
        "for": situation.id
      }
    }, [_vm._v(_vm._s(situation.nome))])])])
  })], 2)]), _c('div', {
    staticClass: "clear"
  }), _c('div', {
    staticClass: "row row-filter-medium"
  }, [_c('div', {
    staticClass: "col-xs-12 px-0"
  }, [_c('button-primary', {
    staticClass: "search-button pull-right",
    attrs: {
      "label": _vm.$t('logDeAuditoria.labels.buscar'),
      "id": "btnConsultaTarefas",
      "type": "submit",
      "disabled": _vm.disableSearchButton
    }
  })], 1)])])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTreegrid),
      expression: "showTreegrid"
    }]
  }, [_c('tree-grid', {
    attrs: {
      "gridId": "assignmentGrid",
      "result": _vm.result,
      "exportUrl": _vm.exportUrl,
      "treeGridFileName": "Tarefas",
      "treeGridLayoutPath": "",
      "cfgObj": _vm.treeGridCfg
    }
  })], 1)], 1)])])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6021cb38", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6021cb38"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/views/administration/assignment/list.pug
// module id = 1419
// module chunks = 0